const FipkartUserToken =
    [
        {
            "https://hasura.io/jwt/claims": {
                "x-hasura-default-role": "OrganizationAdmin",
                "x-hasura-allowed-roles": [
                    "OrganizationAdmin"
                ],
                "x-hasura-user-id": "83ea0a62-79d4-48e7-a7de-f7ad44869eeb",
                "x-hasura-org-id": "e4e3b129-b3f1-40a4-8963-5b51a6c06ec0"
            },
            "user_email": "admin@flipkart.com",
            "isLocationAdmin": true,
            "mappings": [
                {
                    "organization_address_id": "0b39e3d4-ee39-4149-a26a-2d8653079729",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "b6e2a3d2-d11e-4299-a3e5-064a1f20031d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8338b15d-fa02-4e25-a215-5bd73b624ff9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d295afc0-d19b-40c2-a434-f52c95c36d1c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3a3baa54-3c5a-4b42-9043-0f558d41f035",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fbd69237-d9b3-481c-a025-ee0e12863c4b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "283d1a76-f8e6-4907-8999-9ccce018fb40",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f44f0069-428a-400f-b97f-7d0ed9184a8e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ed631664-23c6-4ff7-b380-f4f45b30f248",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c298dfb8-fad3-43ac-b243-fd66d585d865",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "784efbe4-02fb-457d-bb13-469084bca764",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "b4f8ce77-da1f-4dc1-b277-8f86c4fee642",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "680917d8-6f6f-47e6-8b45-a0f527d59793",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5c33cbb0-4b9b-4404-a9c9-f19998fb4bb2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c6b1caf6-f313-43c9-b212-069d11ee3ea2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "bfbcf95a-c710-472d-803b-69c0653a5c16",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0b991327-a473-4507-897a-aa767423af75",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ca3d2d1b-94f9-4116-aff1-57f7568f1639",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "133803f8-0199-491c-95d1-04b90c3ecd4c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "bfd107b1-1f0d-4c4f-a394-61bd5256fe57",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "95baec76-49cd-4028-9cae-cd1b587686bf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d3551f25-7093-4af4-957c-bbd8530ad055",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "eb23338e-ac8e-4553-a74a-e899bee1e9fb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6dd8b68f-96c8-4796-921c-f90226c32249",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0fccac68-d4c2-4a54-b5a9-456de68d3e5b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03fcdfc4-9458-480c-975c-4321ff0a49d9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7c97c05a-f516-490a-9420-5dca98d4447c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8c2c25bc-8023-4b99-a89a-d5996758136a",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "04609f47-2204-4d1c-b9da-de1854ca47a6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "120faccd-e284-4af2-8fc5-a73337e4f233",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4cc92745-5408-4cb1-a0c5-5792ec99df9e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03716d57-48d0-4042-a9e0-9ccc51a69f61",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6d51d2ba-7981-4cf9-996c-758160d7dfdb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8a41c9ee-de12-4fe1-b608-f5ef19c0d361",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "609b91bc-eb9f-4f63-a2ed-b2b0796b1297",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6b5aded0-3680-4deb-a174-a9c1eb344245",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "9f357789-90a8-498d-8fb0-b25134baffa7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d2c0bdd8-825a-489c-9a17-082c239f28c3",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "54eb778a-15d1-4397-91dd-79adad0a0583",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "65ba48cd-d9fa-47f7-a88b-127f411793bf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5580f644-b1e4-49e9-b307-2893a5594dcd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "9288250c-c007-45b8-9096-50fa151052dd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8dc64e1d-07c6-4f06-a74e-d6347b31205b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "06209936-85b7-4238-a43d-e2fd9affd4eb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6c57090f-aaae-44c5-bdb2-244a7d4b20bd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "424b9ae5-de82-48bb-83a4-26ee2071d02f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e987be0e-2a7c-418e-a934-f3b6ff1e37f0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03bd1262-0214-425d-8312-11a88ae8fb11",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "db081760-3b4a-44cc-85e7-adde9358eaf6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "97b83756-2d8e-481a-9146-aba1210dcb9f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "48a176cd-7ce0-4bbc-85a2-9fe60e72c39f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f546b537-3539-489f-ad45-2477aa8c3e28",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "266f2590-2c01-4a11-9fd3-b8a1c1fa2475",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4c41d91f-cebf-4cc3-9389-58e6d6bcf2f2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5bdbd3b5-34bc-4e7f-8c77-f85ef78e7433",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "34352a50-6907-490a-b98a-95c8548c5334",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "510ff70b-1bed-4326-a3a7-f44cd096cbc1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7d050854-d5b1-441b-83bb-cbdde7fa866d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7c5a5ddb-1787-40ff-a0d9-7399212de925",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "9f309ebf-7b8c-4a5d-896c-8a2e6d211979",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3dba5788-7833-4b78-87fa-525eff337c33",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6f535b46-785f-49ec-b410-d89e4f61d8f9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ca668b70-8e8b-4fe9-8162-79c60ff85c62",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a7e2eaa5-a7dc-4a3d-9c63-f12c9ac95e3b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "007bd7a7-95aa-49b7-831a-5c7334e81406",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "bf57bba9-7b5e-4435-bc61-b33aa5169f21",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7d41df1d-ac7d-4791-af94-b659a2fada85",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3b8590c9-1195-49db-b009-278765308e92",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6994af93-30d0-4089-b75e-873b12616046",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a53380a6-e420-40d4-817d-74bde4acfcd4",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "040237e6-5b55-428e-aa96-cdbe3a87bf42",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0d502e30-55d1-4982-83b8-9b0c92c9704e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "cfe1ad23-3812-41ea-a921-5d95f25a61a0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "22050c0a-b73b-48aa-b37b-cc768b10feed",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c7a32f24-c39e-41a5-bd02-fdbb29822f92",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e155196e-976c-4439-8988-1a41a2bb23d1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7a07053d-d2ea-4e8c-822f-f7d93f75e969",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5998e192-9b61-4ff8-9109-d45cbc5d2d7a",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "33bb148d-21f4-4362-bf9d-9fe79f797263",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3fcf3837-8e25-4d6e-bf89-0d945d2bcb5f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e48e25ba-7cad-4471-b949-a9df4e5e0055",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "28bb869c-2792-49df-87b9-8aaecd4f4e06",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c8cb0c3d-7222-4787-bf37-d1c5a259d5ac",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "380cd6e6-02c1-4540-86b0-566d0713cacf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8406bc9b-2e0b-4ad4-89d4-def92405c318",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "75f138a5-b049-4ce1-92f0-2e077a97bee7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8b78fb27-be9e-47df-8bf5-49886e6cc875",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "eb284de4-963d-4981-ad8d-81a1322a40a6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1777a1a1-c98f-42e6-a1f7-5480ab14b06c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a4528d4e-98ea-4e94-b952-dd6dc279cb97",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d7d7e934-8acd-48ae-9ede-c8f23ac0da8e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fbc42cb3-a495-4455-be4e-82e76ce52590",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2bb5793f-2a9d-40d5-af5d-dfe258f5ee1f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7fb667d2-8a32-43ff-ae5d-a1170980edd6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "89f122a4-6424-471e-ad38-17b4bef8e985",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7142e837-2a40-4775-8970-ad0d1071644b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2d294389-51ad-46e2-be45-1e90fc335dd7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "091d18b3-7ba5-4f11-94c6-af70ac8dd00d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3e3c685d-231f-4af7-aab0-5692d8572886",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fddbb413-4b03-4507-adee-b5899c93cf69",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0c39bbfe-14da-4f91-91a3-0b40a3cf7075",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3f16892e-18f8-4ddc-80e9-9a65d16308ac",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1e068681-9d2b-4306-b2ed-1b8f0984c60f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e8472a4a-8bc1-4b38-99e1-760e03ec0234",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f1435406-eb88-4c92-8249-1fbef7893cd3",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "38992f91-98e2-4121-999d-ae2f83e99645",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "10085225-7aaa-4456-b005-cc2939f75517",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "66fbbbf9-8597-4280-b0e1-f21cacfdfa34",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7f08dcd0-4ed5-4f90-b4ad-af4139efd38d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6d910369-f69e-41ce-87cd-92566f5eddb9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c5c420a4-a3a0-492f-b75c-355ddbbf5ca4",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "96a9a194-4a27-4987-8018-61a369dd2190",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "58baaf79-e7d0-4d95-9793-7e71aa8c75ae",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5b433582-9dec-41b9-9d6e-84d8c1c9f146",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5c6495fb-e650-490c-af9e-632f21a52db0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "31e3ab0b-785b-4c9b-a969-2be73ee5dd6e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4766fc67-6955-4147-a2ab-3421181fd70c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6a982f09-020a-4a2f-8879-8732b27449b2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "76337559-2357-4d7c-9fc2-c6630a6dd624",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e338e861-8368-4823-8c0c-6a2bc5c70cca",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "036b280b-3c20-4423-84db-ae778f5c0bf6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "b4c73fcb-d42b-486d-8ac0-f16f91b2436e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "032ef434-7807-47bc-a5d2-8068ef07a04e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "adbd5635-a1f3-4e88-b723-2122ac0c1641",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c88d80bd-fa99-4a13-b119-1c87f508a056",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fdb46aea-412b-41a3-bdc0-15bfc9a9bb6f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a9cd42b5-13ab-4bb7-8c8b-9f066b58d191",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e734201e-edf1-4f80-a2e3-59f5e5297279",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "12a4eb59-53ac-4f3a-a108-eff984a58176",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "45a7493b-05e4-45c3-a904-744fe2259842",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2cdf92d1-8fba-4eff-a34e-53f6ce393cdd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "18d15201-269a-4c94-9756-1e61b8f82bdf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5006fbf2-9bb5-433e-9c79-33e40acc0578",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5cfbf9f9-6033-4f73-8fee-a2ef27a75a52",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fbdf38da-83e7-46e9-b711-5c17fb9f3c20",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1d936b7f-2f6e-44d6-abd6-4b325a06cb39",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ee4257a8-3396-4541-80fa-67afb0a22c2d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4eec6421-2dd7-4a81-aae9-177d9236125b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0bc45a0c-809c-4e48-9fe5-5d94bf2d42fa",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f00504fd-9686-4012-aeeb-50218b66f240",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "089f60a9-c353-4472-bfe7-97bbb4346531",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "842583ad-5844-4670-8f73-443e4edc11d5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "88674232-7ae2-42fd-9368-f5f134d51879",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6e313882-58ee-4c37-aeea-206963fd7f36",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "87d18077-8724-4767-a7ce-84d1d27ff76d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3f095b7e-e77a-4726-9e90-aa2b1c0ee5be",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "63917737-1e76-46c9-aab9-18440ac9e67e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f5b52875-3c9a-4541-a704-0fb67bd89d41",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "07f489ff-aab4-4139-955e-317869c5fa02",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "177cffef-bb53-4629-994c-39059488d4e1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8074b196-1853-40e7-b634-dad735a954fb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f31efa80-fd88-4a06-a502-921e100c705d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "77977f45-0a95-4832-ad2d-34e5ac663810",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03aadad6-a700-4da6-9ad8-937ed25f486e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2476f2c8-b5a9-4130-a212-449584c7d699",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1fc8828d-798c-4ae5-ba80-c551512dc397",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e38867a1-d33d-468a-b479-04b029945e24",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "58a265eb-7d9d-46d9-982f-d880cbaea2e5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a592da74-6f9a-4fb0-b3a0-eac337aec42f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2aca1f3a-7210-4723-90ba-76d556bd6072",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "60c9ba2c-ebca-4328-b7e1-becec1eb6c48",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "861bf119-aa11-4cad-8697-a66c1b246da7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e8fb2a9a-03fa-4aec-8584-9d3615b6491b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "799a7aec-e1b2-4c24-9ae4-d1fb7569ab63",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a2ed5be2-efca-4835-b914-963a07a84617",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3802476e-c145-46bc-9b8b-ad2a7701a891",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f7c72bec-6de9-4df0-918f-1754d79b8563",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "19a089dd-7781-464f-a3ff-8b4ef721a5c5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8d003745-2d91-4c3f-ba9a-72e5f72f269e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "96e7b5bd-e8d1-465d-bb30-591ecdd942ad",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4d421a04-1237-4071-a25f-25317308b6fe",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "60551aa0-1169-4daf-84c7-2c6d1725e862",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "cfe4576f-34b3-4937-a98d-35680d343ed1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "df8f5bf1-7c28-4307-a6d4-28ef1eb23967",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3e21d66f-e3a3-472f-96fa-009547902b77",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "042e4f14-58be-40ca-841b-c838d2925bd0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "045a0bb5-8ab6-47a9-9260-f7d60ce0bc81",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "baae9d20-37d9-4fdd-9d16-2353e93822b5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0bb24db3-9039-44cd-8c03-c4500b8ce22e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a50bca20-0ac9-4476-90ca-104865d6d2b0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                }
            ]
        },
        {
            "https://hasura.io/jwt/claims": {
                "x-hasura-default-role": "LocationExecutive",
                "x-hasura-allowed-roles": [
                    "LocationExecutive"
                ],
                "x-hasura-user-id": "c140cf3c-db7b-4329-9322-760bd448948b",
                "x-hasura-org-id": "e4e3b129-b3f1-40a4-8963-5b51a6c06ec0"
            },
            "user_email": "user1@flipkart.com",
            "isLocationAdmin": false,
            "mappings": [
                {
                    "organization_address_id": "0b39e3d4-ee39-4149-a26a-2d8653079729",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "b6e2a3d2-d11e-4299-a3e5-064a1f20031d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8338b15d-fa02-4e25-a215-5bd73b624ff9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d295afc0-d19b-40c2-a434-f52c95c36d1c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3a3baa54-3c5a-4b42-9043-0f558d41f035",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fbd69237-d9b3-481c-a025-ee0e12863c4b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "283d1a76-f8e6-4907-8999-9ccce018fb40",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f44f0069-428a-400f-b97f-7d0ed9184a8e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ed631664-23c6-4ff7-b380-f4f45b30f248",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c298dfb8-fad3-43ac-b243-fd66d585d865",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "784efbe4-02fb-457d-bb13-469084bca764",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "b4f8ce77-da1f-4dc1-b277-8f86c4fee642",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "680917d8-6f6f-47e6-8b45-a0f527d59793",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5c33cbb0-4b9b-4404-a9c9-f19998fb4bb2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c6b1caf6-f313-43c9-b212-069d11ee3ea2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "bfbcf95a-c710-472d-803b-69c0653a5c16",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0b991327-a473-4507-897a-aa767423af75",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ca3d2d1b-94f9-4116-aff1-57f7568f1639",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "133803f8-0199-491c-95d1-04b90c3ecd4c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "bfd107b1-1f0d-4c4f-a394-61bd5256fe57",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "95baec76-49cd-4028-9cae-cd1b587686bf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d3551f25-7093-4af4-957c-bbd8530ad055",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "eb23338e-ac8e-4553-a74a-e899bee1e9fb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6dd8b68f-96c8-4796-921c-f90226c32249",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0fccac68-d4c2-4a54-b5a9-456de68d3e5b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03fcdfc4-9458-480c-975c-4321ff0a49d9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7c97c05a-f516-490a-9420-5dca98d4447c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8c2c25bc-8023-4b99-a89a-d5996758136a",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "04609f47-2204-4d1c-b9da-de1854ca47a6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "120faccd-e284-4af2-8fc5-a73337e4f233",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4cc92745-5408-4cb1-a0c5-5792ec99df9e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03716d57-48d0-4042-a9e0-9ccc51a69f61",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6d51d2ba-7981-4cf9-996c-758160d7dfdb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8a41c9ee-de12-4fe1-b608-f5ef19c0d361",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "609b91bc-eb9f-4f63-a2ed-b2b0796b1297",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6b5aded0-3680-4deb-a174-a9c1eb344245",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "9f357789-90a8-498d-8fb0-b25134baffa7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d2c0bdd8-825a-489c-9a17-082c239f28c3",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "54eb778a-15d1-4397-91dd-79adad0a0583",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "65ba48cd-d9fa-47f7-a88b-127f411793bf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5580f644-b1e4-49e9-b307-2893a5594dcd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "9288250c-c007-45b8-9096-50fa151052dd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8dc64e1d-07c6-4f06-a74e-d6347b31205b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "06209936-85b7-4238-a43d-e2fd9affd4eb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6c57090f-aaae-44c5-bdb2-244a7d4b20bd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "424b9ae5-de82-48bb-83a4-26ee2071d02f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e987be0e-2a7c-418e-a934-f3b6ff1e37f0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03bd1262-0214-425d-8312-11a88ae8fb11",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "db081760-3b4a-44cc-85e7-adde9358eaf6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "97b83756-2d8e-481a-9146-aba1210dcb9f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "48a176cd-7ce0-4bbc-85a2-9fe60e72c39f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f546b537-3539-489f-ad45-2477aa8c3e28",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "266f2590-2c01-4a11-9fd3-b8a1c1fa2475",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4c41d91f-cebf-4cc3-9389-58e6d6bcf2f2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5bdbd3b5-34bc-4e7f-8c77-f85ef78e7433",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "34352a50-6907-490a-b98a-95c8548c5334",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "510ff70b-1bed-4326-a3a7-f44cd096cbc1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7d050854-d5b1-441b-83bb-cbdde7fa866d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7c5a5ddb-1787-40ff-a0d9-7399212de925",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "9f309ebf-7b8c-4a5d-896c-8a2e6d211979",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3dba5788-7833-4b78-87fa-525eff337c33",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6f535b46-785f-49ec-b410-d89e4f61d8f9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ca668b70-8e8b-4fe9-8162-79c60ff85c62",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a7e2eaa5-a7dc-4a3d-9c63-f12c9ac95e3b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "007bd7a7-95aa-49b7-831a-5c7334e81406",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "bf57bba9-7b5e-4435-bc61-b33aa5169f21",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7d41df1d-ac7d-4791-af94-b659a2fada85",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3b8590c9-1195-49db-b009-278765308e92",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6994af93-30d0-4089-b75e-873b12616046",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a53380a6-e420-40d4-817d-74bde4acfcd4",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "040237e6-5b55-428e-aa96-cdbe3a87bf42",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0d502e30-55d1-4982-83b8-9b0c92c9704e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "cfe1ad23-3812-41ea-a921-5d95f25a61a0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "22050c0a-b73b-48aa-b37b-cc768b10feed",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c7a32f24-c39e-41a5-bd02-fdbb29822f92",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e155196e-976c-4439-8988-1a41a2bb23d1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7a07053d-d2ea-4e8c-822f-f7d93f75e969",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5998e192-9b61-4ff8-9109-d45cbc5d2d7a",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "33bb148d-21f4-4362-bf9d-9fe79f797263",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3fcf3837-8e25-4d6e-bf89-0d945d2bcb5f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e48e25ba-7cad-4471-b949-a9df4e5e0055",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "28bb869c-2792-49df-87b9-8aaecd4f4e06",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c8cb0c3d-7222-4787-bf37-d1c5a259d5ac",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "380cd6e6-02c1-4540-86b0-566d0713cacf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8406bc9b-2e0b-4ad4-89d4-def92405c318",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "75f138a5-b049-4ce1-92f0-2e077a97bee7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8b78fb27-be9e-47df-8bf5-49886e6cc875",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "eb284de4-963d-4981-ad8d-81a1322a40a6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1777a1a1-c98f-42e6-a1f7-5480ab14b06c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a4528d4e-98ea-4e94-b952-dd6dc279cb97",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "d7d7e934-8acd-48ae-9ede-c8f23ac0da8e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fbc42cb3-a495-4455-be4e-82e76ce52590",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2bb5793f-2a9d-40d5-af5d-dfe258f5ee1f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7fb667d2-8a32-43ff-ae5d-a1170980edd6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "89f122a4-6424-471e-ad38-17b4bef8e985",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7142e837-2a40-4775-8970-ad0d1071644b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2d294389-51ad-46e2-be45-1e90fc335dd7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "091d18b3-7ba5-4f11-94c6-af70ac8dd00d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3e3c685d-231f-4af7-aab0-5692d8572886",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fddbb413-4b03-4507-adee-b5899c93cf69",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0c39bbfe-14da-4f91-91a3-0b40a3cf7075",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3f16892e-18f8-4ddc-80e9-9a65d16308ac",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1e068681-9d2b-4306-b2ed-1b8f0984c60f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e8472a4a-8bc1-4b38-99e1-760e03ec0234",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f1435406-eb88-4c92-8249-1fbef7893cd3",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "38992f91-98e2-4121-999d-ae2f83e99645",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "10085225-7aaa-4456-b005-cc2939f75517",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "66fbbbf9-8597-4280-b0e1-f21cacfdfa34",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "7f08dcd0-4ed5-4f90-b4ad-af4139efd38d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6d910369-f69e-41ce-87cd-92566f5eddb9",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c5c420a4-a3a0-492f-b75c-355ddbbf5ca4",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "96a9a194-4a27-4987-8018-61a369dd2190",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "58baaf79-e7d0-4d95-9793-7e71aa8c75ae",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5b433582-9dec-41b9-9d6e-84d8c1c9f146",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5c6495fb-e650-490c-af9e-632f21a52db0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "31e3ab0b-785b-4c9b-a969-2be73ee5dd6e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4766fc67-6955-4147-a2ab-3421181fd70c",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6a982f09-020a-4a2f-8879-8732b27449b2",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "76337559-2357-4d7c-9fc2-c6630a6dd624",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e338e861-8368-4823-8c0c-6a2bc5c70cca",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "036b280b-3c20-4423-84db-ae778f5c0bf6",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "b4c73fcb-d42b-486d-8ac0-f16f91b2436e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "032ef434-7807-47bc-a5d2-8068ef07a04e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "adbd5635-a1f3-4e88-b723-2122ac0c1641",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "c88d80bd-fa99-4a13-b119-1c87f508a056",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fdb46aea-412b-41a3-bdc0-15bfc9a9bb6f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a9cd42b5-13ab-4bb7-8c8b-9f066b58d191",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e734201e-edf1-4f80-a2e3-59f5e5297279",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "12a4eb59-53ac-4f3a-a108-eff984a58176",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "45a7493b-05e4-45c3-a904-744fe2259842",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2cdf92d1-8fba-4eff-a34e-53f6ce393cdd",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "18d15201-269a-4c94-9756-1e61b8f82bdf",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5006fbf2-9bb5-433e-9c79-33e40acc0578",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "5cfbf9f9-6033-4f73-8fee-a2ef27a75a52",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "fbdf38da-83e7-46e9-b711-5c17fb9f3c20",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1d936b7f-2f6e-44d6-abd6-4b325a06cb39",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "ee4257a8-3396-4541-80fa-67afb0a22c2d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4eec6421-2dd7-4a81-aae9-177d9236125b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0bc45a0c-809c-4e48-9fe5-5d94bf2d42fa",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f00504fd-9686-4012-aeeb-50218b66f240",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "089f60a9-c353-4472-bfe7-97bbb4346531",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "842583ad-5844-4670-8f73-443e4edc11d5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "88674232-7ae2-42fd-9368-f5f134d51879",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "6e313882-58ee-4c37-aeea-206963fd7f36",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "87d18077-8724-4767-a7ce-84d1d27ff76d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3f095b7e-e77a-4726-9e90-aa2b1c0ee5be",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "63917737-1e76-46c9-aab9-18440ac9e67e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f5b52875-3c9a-4541-a704-0fb67bd89d41",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "07f489ff-aab4-4139-955e-317869c5fa02",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "177cffef-bb53-4629-994c-39059488d4e1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8074b196-1853-40e7-b634-dad735a954fb",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f31efa80-fd88-4a06-a502-921e100c705d",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "77977f45-0a95-4832-ad2d-34e5ac663810",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "03aadad6-a700-4da6-9ad8-937ed25f486e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2476f2c8-b5a9-4130-a212-449584c7d699",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "1fc8828d-798c-4ae5-ba80-c551512dc397",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e38867a1-d33d-468a-b479-04b029945e24",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "58a265eb-7d9d-46d9-982f-d880cbaea2e5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a592da74-6f9a-4fb0-b3a0-eac337aec42f",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "2aca1f3a-7210-4723-90ba-76d556bd6072",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "60c9ba2c-ebca-4328-b7e1-becec1eb6c48",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "861bf119-aa11-4cad-8697-a66c1b246da7",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "e8fb2a9a-03fa-4aec-8584-9d3615b6491b",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "799a7aec-e1b2-4c24-9ae4-d1fb7569ab63",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a2ed5be2-efca-4835-b914-963a07a84617",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3802476e-c145-46bc-9b8b-ad2a7701a891",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "f7c72bec-6de9-4df0-918f-1754d79b8563",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "19a089dd-7781-464f-a3ff-8b4ef721a5c5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "8d003745-2d91-4c3f-ba9a-72e5f72f269e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "96e7b5bd-e8d1-465d-bb30-591ecdd942ad",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "4d421a04-1237-4071-a25f-25317308b6fe",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "60551aa0-1169-4daf-84c7-2c6d1725e862",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "cfe4576f-34b3-4937-a98d-35680d343ed1",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "df8f5bf1-7c28-4307-a6d4-28ef1eb23967",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "3e21d66f-e3a3-472f-96fa-009547902b77",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "042e4f14-58be-40ca-841b-c838d2925bd0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "045a0bb5-8ab6-47a9-9260-f7d60ce0bc81",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "baae9d20-37d9-4fdd-9d16-2353e93822b5",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "0bb24db3-9039-44cd-8c03-c4500b8ce22e",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                },
                {
                    "organization_address_id": "a50bca20-0ac9-4476-90ca-104865d6d2b0",
                    "activities": [
                        "general",
                        "production",
                        "energy",
                        "transport",
                        "waste", "water"
                    ]
                }
            ]
        },
        {
            "https://hasura.io/jwt/claims": {
              "x-hasura-default-role": "LocationExecutive",
              "x-hasura-allowed-roles": [
                "LocationExecutive"
              ],
              "x-hasura-user-id": "b80216bc-91a4-437a-a1a6-e5768949a3f4",
              "x-hasura-org-id": "e4e3b129-b3f1-40a4-8963-5b51a6c06ec0"
            },
            "user_email": "ravi@indiaservices.com",
            "mappings": [
              {
                "organization_address_id": "19bf1c9d-0351-4f20-bddb-5f695c83f8e4",
                "activities": [
                  "general",
                  "production",
                  "energy",
                  "transport",
                  "waste"
                ]
              }
            ]
          }
    ];


export const getUserMappingDetails = (userEmail) => {
    let arr = [];
    if (FipkartUserToken.find(user => user.user_email === userEmail) === undefined) {

    } else {
        arr = FipkartUserToken.find(user => user.user_email === userEmail).mappings
    }
    return arr;

}
export const isFlipkartUser = (userEmail) => {
    return !!FipkartUserToken.find(user => user.user_email === userEmail)
}
export const isFlipkartLocationExecutiveUser = (userEmail) => {
    return !!FipkartUserToken.find(user => user.user_email === userEmail && user.isLocationAdmin === false)
}
export const isFlipkartLocationAdminUser = (userEmail) => {
    return !!FipkartUserToken.find(user => user.user_email === userEmail && user.isLocationAdmin === true)
}